import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../store/actions'
import DefaultLayout from '../../layouts/default'
import ContactForm from '../../components/forms/contact'
import Loading from '../../components/loading'

function mapStateToProps(state) {
  return { page: state.pageSlugData[0] };
}

const mapDispatchToProps = (dispatch) => {
  const { fetchPageBySlug } = actions;
  return {
    fetchPageBySlug: bindActionCreators(fetchPageBySlug, dispatch),
  }
}

class Contact extends React.Component {
  componentWillMount() {
    this.props.fetchPageBySlug('contact');
  }

  render() {
    const page = this.props.page;

    if (!this.props.page) { return <Loading /> }

    return (
      <DefaultLayout pagetitle={ this.props.pagetitle }>
        <div className="contact-page">
          <div className="container container--grid">
            <div className="row">
              <div className="col col--md-6">
                <p dangerouslySetInnerHTML={{ __html: page.content.rendered }}></p>
              </div>
              <div className="col col--md-6">
                <div className="appointment">
                  <ContactForm title="Schedule an appointment" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/routes/contact/index.js